/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LoginMetadata} from '../models/LoginMetadata';
import type {LoginMetadataSaveRequest} from '../models/LoginMetadataSaveRequest';

export interface GetLoginMetadata$Request {
    userId: number;
}

export interface GetLoginMetadata$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLoginMetadataRequest = createAction<PayloadData<void, GetLoginMetadata$Request>>('USER_LOGIN_METADATA__GET_LOGIN_METADATA__REQUEST');
export const getLoginMetadataSuccess = createAction<PayloadData<LoginMetadata, GetLoginMetadata$Request>>('USER_LOGIN_METADATA__GET_LOGIN_METADATA__SUCCESS');
export const getLoginMetadataFailure = createAction<PayloadData<Error, GetLoginMetadata$Request, true>>('USER_LOGIN_METADATA__GET_LOGIN_METADATA__FAILURE');

export const getLoginMetadataActions = [
    getLoginMetadataRequest,
    getLoginMetadataSuccess,
    getLoginMetadataFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLoginMetadata = (meta: GetLoginMetadata$Request, config?: GetLoginMetadata$Config) => {
    return {
        CALL_API: {
            types: getLoginMetadataActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/login/metadata`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveLoginMetadata$Request {
    userId: number;
    loginMetadataSaveRequest?: LoginMetadataSaveRequest;
}

export interface SaveLoginMetadata$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveLoginMetadataRequest = createAction<PayloadData<void, SaveLoginMetadata$Request>>('USER_LOGIN_METADATA__SAVE_LOGIN_METADATA__REQUEST');
export const saveLoginMetadataSuccess = createAction<PayloadData<void, SaveLoginMetadata$Request>>('USER_LOGIN_METADATA__SAVE_LOGIN_METADATA__SUCCESS');
export const saveLoginMetadataFailure = createAction<PayloadData<Error, SaveLoginMetadata$Request, true>>('USER_LOGIN_METADATA__SAVE_LOGIN_METADATA__FAILURE');

export const saveLoginMetadataActions = [
    saveLoginMetadataRequest,
    saveLoginMetadataSuccess,
    saveLoginMetadataFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {LoginMetadataSaveRequest} [meta.loginMetadataSaveRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveLoginMetadata = (meta: SaveLoginMetadata$Request, config?: SaveLoginMetadata$Config) => {
    return {
        CALL_API: {
            types: saveLoginMetadataActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/login/metadata`,
            TRANSPORT_REQUEST_BODY: meta.loginMetadataSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

